import React from "react";
import "./cta.css";
import {
  FaPhone,
  FaEnvelope,
  FaMapMarkerAlt,
  FaLinkedin,
  FaInstagram,
  FaFacebook,
  FaTwitter,
} from "react-icons/fa";

function CTA({ whiteBackground }) {
  return (
    <section className={`contact-section ${whiteBackground ? "white-bg" : ""}`}>
      <div className="container">
        <p className="section-sub">\ Get In Touch \</p>
        <h2
          className={`section-title ${
            whiteBackground ? "white-bg" : "dark-bg"
          }`}
        >
          Hey! Let's Talk
        </h2>
        <div className="contact-grid">
          <form className="contact-form">
            <input type="text" placeholder="Name" />
            <input type="email" placeholder="Email" />
            <input type="text" placeholder="Phone" />
            <textarea placeholder="Your Message" rows="5" />
            <button type="submit">Send Now</button>
          </form>
          <div className="contact-info">
            <div className="contact-item">
              <div className="icon-box">
                <FaPhone />
              </div>
              <div>
                <h4>Call Anytime</h4>
                <p>
                  +66 92-256-8607
                  <br />
                  +66 92-256-8607
                </p>
              </div>
            </div>
            <div className="contact-item">
              <div className="icon-box">
                <FaEnvelope />
              </div>
              <div>
                <h4>Send Email</h4>
                <p>
                  Apinut5864@gmail.com
                  <br />
                  Apinut5864@gmail.com
                </p>
              </div>
            </div>
            <div className="contact-item">
              <div className="icon-box">
                <FaMapMarkerAlt />
              </div>
              <div>
                <h4>Visit Us</h4>
                <p>
                  2027/8 ซอยเจริญกรุง 77 ถนนเจริญกรุง วัดพระยาไกร เขตบางคอแหลม
                  <br />
                  กรุงเทพมหานคร
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default CTA;
